import React, {useEffect, useState} from 'react';
import IntlMessage from "../../../../../components/IntlMessage/IntlMessage";
import {useDispatch, useSelector} from "react-redux";
import {changeCurrentPage} from "../../../../../store/slices/tableController/MicroQualificationListTableController";
import MyText from "../../../../../components/UI/Text/MyText";
import {Button, Flex, Form, Input, message, Modal, Tag} from "antd";
import MyTable from "../../../../../components/Table/MyTable";
import {getAllMicroQualifications} from "../../../../../store/slices/MicroqualificationsSlice";
import {LocalName} from "../../../../../utils/LocalName";
import {useNavigate} from "react-router-dom";
import classes from "../../Applications/application.module.css";
import MicroQualificationService from "../../../../../services/MicroQualificationService";
import {useTranslation} from "react-i18next";
import {clrs} from "../../../../../constants/colors";
import FormItem from "antd/es/form/FormItem";

const MicroQualificationList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const {t} = useTranslation();

    const regNumber = Form.useWatch('regNumber', form);
    const regDate = Form.useWatch('regDate', form)

    const {microQualifications, isLoading, hasMore, error} = useSelector(state => state.microQualificationList)
    const {currentPage, pageSize} = useSelector(state => state.microQualificationListTableController);

    const [isLoadingCreate, setIsLoadingCreate] = useState(false);
    const [openModal, setOpenModal] = useState(false)
    const [micro, setMicro] = useState(null)

    const columns = [
        {
            title: <MyText center strong><IntlMessage id={"educationField"}/></MyText>,
            render: (_, record) => (
                <MyText center>{LocalName.getName(record.educationField)}</MyText>
            ),
            width: '15%',
        },
        {
            title: <MyText center strong><IntlMessage id={"trainingDirection"}/></MyText>,
            render: (_, record) => (
                <MyText center>{LocalName.getName(record.trainingDirection)}</MyText>
            ),
            width: '15%',
        },
        {
            title: <MyText center strong><IntlMessage id={"groupEP"}/></MyText>,
            render: (_, record) => (
                <MyText center>{LocalName.getName(record.groupEP)}</MyText>
            ),
            width: '15%',
        },
        {
            title: <MyText center strong><IntlMessage id={"microQEP"}/></MyText>,
            render: (_, record) => (
                <MyText center>{LocalName.getName(record.name)}</MyText>
            ),
            width: '15%',
        },
        {
            title: <MyText center strong><IntlMessage id={"partnerOrg"}/></MyText>,
            render: (_, record) => (
                <MyText center>{LocalName.getName(record.partnerOrg)}</MyText>
            ),
            width: '15%',
        },
        {
            title: <MyText center strong><IntlMessage id={"opType"}/></MyText>,
            render: (_, record) => (
                <MyText center>{LocalName.getName(record.status)}</MyText>
            ),
            width: '10%',
        },
        {
            title: <MyText center strong><IntlMessage id={"status"}/></MyText>,
            render: (_, record) => (
                <MyText center>{record.isApproved ?
                    (!!record.regNumber && !!record.regDate) ? <Tag color={clrs.darkerGreen}><IntlMessage id={"registered"}/></Tag> :
                    <Tag color={clrs.darkerGreen}><IntlMessage id={"DIRECTOR_AGREED"}/></Tag> : record.isSendToCheck ?
                        <Tag color={clrs.blue}><IntlMessage id={"sentToCheck"}/></Tag> :
                        <Tag color={clrs.orange}><IntlMessage id={"SENT_REVISION"}/></Tag>}</MyText>
            ),
            width: '10%',
        },
        {
            title: <MyText center strong><IntlMessage id={"mEditor"}/></MyText>,
            render: (_, record) => (
                <MyText center>{record?.fullName}</MyText>
            ),
            width: '15%',
        },
        {
            title: <MyText center strong><IntlMessage id={"actions"}/></MyText>,
            render: (_, record) => (
                <>
                    <Flex style={{width: "100%"}} align={"center"} justify={"center"} wrap={"wrap"} gap={20}>
                        {/*<p onClick={() => navigate(`/p/microqualification/${record.id}/edit`)}*/}
                        {/*   className={classes.copyLinkBtn}>*/}
                        {/*    <IntlMessage id={'edit'}/>*/}
                        {/*</p>*/}
                        <p onClick={() => navigate(`/p/microqualification/${record.id}/view`)}
                           className={classes.copyLinkBtn}>
                            <IntlMessage id={'view'}/>
                        </p>
                        {(record.isApproved && !record.regNumber) &&
                            <p onClick={() => {
                                setMicro(record.id);
                                setOpenModal(true);
                            }}
                               className={classes.copyLinkBtn}>
                                <IntlMessage id={'register'}/>
                            </p>
                        }

                        <p onClick={() => downloadDocument(record.id)}
                           className={classes.historyEventsBtn}>
                            <IntlMessage id={'download'}/>
                        </p>
                    </Flex>
                </>

            ),
            width: '15%',
        },
    ];

    useEffect(() => {
        dispatch(getAllMicroQualifications({
            page: currentPage,
            limit: pageSize,
            role: 'director'
        }));
    }, []);

    async function downloadDocument(id) {
        message.loading(<IntlMessage id={'loading'}/>, 0);
        await MicroQualificationService.getResource(id)
            .then((r) => {
                message.destroy();
                message.success(<IntlMessage id={'success'}/>, 5);

                triggerDownload(r.data, "act_completion_work.pdf")
            })
            .catch(() => {
                message.destroy();
                message.error(<IntlMessage id={'error'}/>, 5);
            })
    }

    function triggerDownload(blob, filename) {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename); // Set the download attribute with a filename
        document.body.appendChild(link);
        link.click();

        // Clean up and revoke the URL after download
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }

    const fetchData = async (params) => {
        return dispatch(getAllMicroQualifications({
            ...params,
            role: 'director'
        }));
    }

    const saveCurrentPageSettings = (page, pageSize) => {
        dispatch(changeCurrentPage({page: page, pageSize: pageSize}));
    };

    async function registerMicroqualification() {
        message.loading(<IntlMessage id={'loading'}/>, 0);
        await MicroQualificationService.registerMicroqualification(regNumber, regDate, micro)
            .then((r) => {
                message.destroy();
                message.success(<IntlMessage id={'success'}/>, 5);
            })
            .catch(() => {
                message.destroy();
                message.error(<IntlMessage id={'error'}/>, 5);
            })
            .finally(() => {
                dispatch(getAllMicroQualifications({
                    page: currentPage,
                    limit: pageSize,
                    role: 'director'
                }));
                setOpenModal(false);
                setMicro(null)
            })
    }

    return (
        <Flex style={{width: "100%"}} gap={20} align={"flex-start"} justify={"flex-start"} vertical>
            <MyText uppercase strong size={"large"}><IntlMessage id={'microQualification'}/></MyText>
            <MyTable
                isLoading={isLoading || isLoadingCreate}
                dataSource={microQualifications}
                columns={columns}
                fetchData={fetchData}
                saveCurrentPage={saveCurrentPageSettings}
                initialPage={currentPage}
                initialPageSize={pageSize}
                hasMore={hasMore}
            />
            <Form form={form}>
                <Modal
                    width={400}
                    maskClosable={true}
                    title={<IntlMessage id={'microQualification'}/>}
                    open={openModal && micro != null}
                    okText={<IntlMessage id={'save'}/>}
                    cancelText={<IntlMessage id={'close'}/>}
                    onOk={() => {
                        setOpenModal(false)
                    }}
                    onCancel={() => {
                        setOpenModal(false)
                    }}
                    footer={[
                        <Button key="submit" type="primary" onClick={registerMicroqualification}>
                            <IntlMessage id={"save"}/>
                        </Button>
                    ]}
                >
                    {
                        openModal &&
                        <Flex style={{width: "100%", position: "relative"}} vertical gap={10}>
                            <FormItem rules={[{
                                required: openModal,
                                message: <IntlMessage id={'requiredField'}/>,
                            },
                            ]} label={<IntlMessage id={'registerNumber'}/>} labelCol={{span: 24}}
                                      className={classes.formInputBlock}
                                      name="regNumber">
                                <Input/>
                            </FormItem>
                            <FormItem rules={[{
                                required: openModal,
                                message: <IntlMessage id={'requiredField'}/>,
                            },
                            ]} label={<IntlMessage id={'registerDate'}/>} labelCol={{span: 24}}
                                      className={classes.formInputBlock}
                                      name="regDate">
                                <Input type={'date'} className={classes.formInput} style={{maxWidth: 200}}/>
                            </FormItem>
                        </Flex>
                    }
                </Modal>
            </Form>
        </Flex>
    );
};

export default MicroQualificationList;